import styled from 'styled-components';
import PropTypes from 'prop-types';
import { RiEdit2Fill } from 'react-icons/ri';
import { MdDeleteForever } from 'react-icons/md';
import { BsMenuButtonWide } from 'react-icons/bs';

const Wrapper = styled.section`
  border-radius: var(--border-radius);
  width: 100%;
  margin: 2.5rem 0 0 0;
  background: var(--background-color);
  padding: 1rem 2rem 1rem;
  border-bottom: 5px solid var(--primary-500);

  .floor-row {
    display: grid;
    grid-template-columns: 1fr 2fr auto;
    align-items: center;
    margin-bottom: 1rem;
    gap: 1rem;
  }

  label {
    display: flex;
    align-items: center; 
  }

  .button-container {
    display: flex;
    gap: 1.5rem;
  }

  button {
    background: none;
    border: none;
    font-size: 1.8rem;
    color: var(--text-color);
    cursor: pointer;
  }
`;

const FloorRow = ({ floor, editFloor, deleteFloor }) => {
  return (
    <Wrapper>
      <div className='floor-row'>
        <h3>{floor.floorNumber}</h3>
        <h3>{floor.floorName}</h3>
        <div className='button-container'>
          <button onClick={editFloor}>
            <RiEdit2Fill />
          </button>
          <button onClick={deleteFloor}>
            <MdDeleteForever />
          </button>
          <button onClick={() => {/* Navigate to business page logic here */}}>
            <BsMenuButtonWide />
          </button>
        </div>
      </div>
    </Wrapper>
  );
};

FloorRow.propTypes = {
  floor: PropTypes.object.isRequired,
  editFloor: PropTypes.func.isRequired,
  deleteFloor: PropTypes.func.isRequired,
};

export default FloorRow;
